export default [
  { title: 'Planning', route: 'planning', icon: 'CalendarIcon' },
  { title: 'Jeunes', route: 'youngs', icon: 'FileTextIcon' },
  { title: 'Répondeur', route: 'history', icon: 'PhoneIcon' },
  { title: 'Blocklist', route: 'blocklist', icon: 'MinusCircleIcon' },
  { title: 'Statistiques', route: 'statistics', icon: 'BarChart2Icon' },
  { title: 'Utilisateurs', route: 'utilisateurs', icon: 'UsersIcon' },
]
